module.exports = __webpack_public_path__ + "static/img/emon-logo.5d9621cc.jpg";